import __base_store from '@/store/__base_store'

/**
 * Store de sugerencias de stock.
 */
export default __base_store({
	state: {
		model_name: 'stock_suggestion',
	},
})

